export const WORKFLOW_DOC_PENDING = 18
export const WORKFLOW_DOC_APPROVED = 19
export const WORKFLOW_DOC_REJECTED = 20

export const requiredDocWorkflows = {
    [WORKFLOW_DOC_PENDING]: 'Pendiente para aprobar',
    [WORKFLOW_DOC_APPROVED]: 'Aprobado',
    [WORKFLOW_DOC_REJECTED]: 'Rechazado'
}
